
export const environment = {
    production: true,
    envName: 'demo',
    apiHost: 'https://watchdog.pov-wd.com/builder',
    auth: {
        // Cognito pool backing this deployment. The SPA is a public client: it holds no secret,
        // and uses authorization code flow with PKCE.
        authority: 'https://cognito-idp.us-east-1.amazonaws.com/us-east-1_g53Gc9slh',
        clientId: '77v1pu3ef2fedpvce3hv2p3b9c',
        redirectUrl: 'https://admin.pov-wd.com/',
        postLogoutRedirectUri: 'https://admin.pov-wd.com/',
        // Cognito's RP-initiated logout lives on the hosted-UI domain, not the issuer.
        logoutUrl: 'https://techwish-ai-sdet.auth.us-east-1.amazoncognito.com/logout',
        scope: 'openid email profile',
    },
};
